import { render, staticRenderFns } from "./ProductMasterMatrixRow.vue?vue&type=template&id=0848f46c&scoped=true&"
import script from "./ProductMasterMatrixRow.vue?vue&type=script&lang=js&"
export * from "./ProductMasterMatrixRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductMasterMatrixRow.vue?vue&type=style&index=0&id=0848f46c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0848f46c",
  null
  
)

export default component.exports